import _ from 'lodash';

import { handleErrors } from './ErrorActions';
import { fetchAdvancedCriteriaSuccess } from './SearchPageActions';
import * as searchTreeViewDataApi from '../api/searchtreeviewdata';

export const GET_SEARCH_TREE_VIEW_DATA = 'SearchTreeViewData/GET_SEARCH_TREE_VIEW_DATA';
export const GET_SEARCH_TREE_VIEW_DATA_SUCCESS =
  'SearchTreeViewData/GET_SEARCH_TREE_VIEW_DATA_SUCCESS';
export const GET_SEARCH_TREE_VIEW_DATA_FAILURE =
  'SearchTreeViewData/GET_SEARCH_TREE_VIEW_DATA_FAILURE';

export const GET_ENHANCED_SEARCH_TREE_VIEW_DATA =
  'SearchTreeViewData/GET_ENHANCED_SEARCH_TREE_VIEW_DATA';
export const GET_ENHANCED_SEARCH_TREE_VIEW_DATA_SUCCESS =
  'SearchTreeViewData/GET_ENHANCED_SEARCH_TREE_VIEW_DATA_SUCCESS';
export const GET_ENHANCED_SEARCH_TREE_VIEW_DATA_FAILURE =
  'SearchTreeViewData/GET_ENHANCED_SEARCH_TREE_VIEW_DATA_FAILURE';

export const RESET_SEARCH_TREE_VIEW_DATA = 'SearchTreeViewData/RESET_SEARCH_TREE_VIEW_DATA';

export const resetSearchTreeViewData = () => ({
  type: RESET_SEARCH_TREE_VIEW_DATA,
});

export const getSearchTreeViewDataSuccess = (entityName, searchTreeViewData) => ({
  type: GET_SEARCH_TREE_VIEW_DATA_SUCCESS,
  payload: {
    entityName,
    searchTreeViewData,
  },
});

export const getSearchTreeViewDataFailure = (entityName, error) => ({
  type: GET_SEARCH_TREE_VIEW_DATA_FAILURE,
  payload: {
    entityName,
    error,
  },
});

export const getSearchTreeViewData = (entityName) => async (dispatch, getState) => {
  const { searchTreeViewData } = getState();
  const entitySearchTreeViewState = searchTreeViewData[entityName];

  if (_.isPlainObject(_.get(entitySearchTreeViewState, 'searchTreeViewData'))) {
    return;
  }

  dispatch({
    type: GET_SEARCH_TREE_VIEW_DATA,
    payload: {
      entityName,
    },
  });

  try {
    if (entityName !== 'ALL') {
      const res = await searchTreeViewDataApi.getSearchTreeViewData(entityName);

      if (res.hasError) {
        throw res.errors;
      }

      const error = _.get(res, ['treeViewData', 'Error']);

      if (!_.isNil(error)) {
        throw error;
      }

      dispatch(getSearchTreeViewDataSuccess(entityName, res.treeViewData));
    } else {
      dispatch(getSearchTreeViewDataSuccess('ALL', {}));
    }
  } catch (error) {
    dispatch(handleErrors(error));

    dispatch(getSearchTreeViewDataFailure(entityName, error));
  }
};

export const getEnhancedSearchTreeViewDataSuccess = (
  entityName,
  advancedSearchCriteria,
  treeViewData
) => ({
  type: GET_ENHANCED_SEARCH_TREE_VIEW_DATA_SUCCESS,
  payload: {
    entityName,
    treeViewData,
    advancedSearchCriteria,
  },
});

export const getEnhancedSearchTreeViewDataFailure = (entityName, error) => ({
  type: GET_ENHANCED_SEARCH_TREE_VIEW_DATA_FAILURE,
  payload: {
    entityName,
    error,
  },
});

export const getEnhancedSearchTreeViewData = (entityName) => async (dispatch, getState) => {
  const { searchTreeViewData } = getState();
  const entitySearchTreeViewState = searchTreeViewData[entityName];

  if (_.isPlainObject(_.get(entitySearchTreeViewState, 'searchTreeViewData'))) {
    return;
  }

  dispatch({
    type: GET_ENHANCED_SEARCH_TREE_VIEW_DATA,
    payload: {
      entityName,
    },
  });

  try {
    const {
      advancedSearchCriteria,
      treeViewData,
      ...response
    } = await searchTreeViewDataApi.getEnhancedSearchTreeViewData(entityName);

    if (response.hasError) {
      dispatch(handleErrors(response.errors, { isTopBanner: true }));
      dispatch(getEnhancedSearchTreeViewDataFailure(entityName, response.errors));
      return;
    }

    dispatch(
      getEnhancedSearchTreeViewDataSuccess(entityName, advancedSearchCriteria, treeViewData)
    );
    dispatch(fetchAdvancedCriteriaSuccess(advancedSearchCriteria));
  } catch (error) {
    dispatch(handleErrors(error));
    dispatch(getEnhancedSearchTreeViewDataFailure(entityName, error));
  }
};
